import { useFormProvider } from "../../../../providers";
import { FormInput } from "components";

export function ServiceCenterComponent() {
  const { serviceCenter } = useFormProvider();

  return <FormInput.ServiceCenterSelect value={serviceCenter} disabled />;
}
